<script setup lang="ts">
import { getActiveChatModule } from '@/environment/environment'
import EmbeddedChatMatrix from '@/modules/chat-matrix-fast/components/EmbeddedChat.vue'

const props = defineProps<{
  chatId: number | null
  connectError?: string | null
}>()

defineEmits<{
  (e: 'hideChat'): void
}>()

const activeModule = getActiveChatModule()
const EmbeddedChat = activeModule === 'matrix'
  ? EmbeddedChatMatrix
  : null
</script>

<template>
  <component
    :is="EmbeddedChat"
    v-if="EmbeddedChat"
    :chat-id="props.chatId"
    :connect-error="activeModule === 'matrix' ? props.connectError : undefined"
    @hide-chat="$emit('hideChat')"
  />
</template>
